import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, unref as _unref, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
const _hoisted_1 = ["src"];
import { ThemeModal } from '../../front/components';
import { ref } from 'vue';
import { dispatchGtmEvent } from '../../front/gtm';
export default /*@__PURE__*/ _defineComponent({
    __name: 'ConferenceBookingModal',
    props: {
        bookingFormUrl: {},
        controller: {}
    },
    setup(__props, { expose: __expose }) {
        const props = __props;
        const modal = ref();
        __expose({
            show,
        });
        function show() {
            var _a;
            (_a = modal.value) === null || _a === void 0 ? void 0 : _a.show();
        }
        function onShown() {
            dispatchGtmEvent(`SKP.EventBookingForm.${props.controller.json.eventType}.shown`, {
                bookingFormUrl: props.bookingFormUrl,
                eventType: props.controller.json.eventType,
                eventMode: props.controller.json.eventMode,
            });
        }
        return (_ctx, _cache) => {
            return (_openBlock(), _createBlock(_unref(ThemeModal), {
                ref_key: "modal",
                ref: modal,
                classes: ['confBooking'],
                onShown: onShown
            }, {
                default: _withCtx(() => [
                    _createElementVNode("div", null, [
                        _createElementVNode("iframe", { src: _ctx.bookingFormUrl }, null, 8, _hoisted_1)
                    ])
                ]),
                _: 1
            }, 512));
        };
    }
});
